import { useQuery } from 'react-query';
import OrdersApi, { ICloneOrderSourceDetails } from '../../OrdersApi';

// cacheTime: 0 drops the cached snapshot as soon as the modal (its only observer) unmounts.
// Combined with conditionally mounting the modal, every open starts with no data and fetches
// current details afresh, so the seed effect can never seed from a stale cached snapshot.
export function useCloneOrderSourceDetails(orderId: number, enabled: boolean) {
    return useQuery<ICloneOrderSourceDetails>(
        ['clone-order-source-details', orderId],
        () => OrdersApi.getCloneDetails(orderId),
        { enabled, cacheTime: 0 }
    );
}
